import { render } from "./AudioCourseware.vue?vue&type=template&id=7e3c0437&scoped=true"
import script from "./AudioCourseware.vue?vue&type=script&lang=js"
export * from "./AudioCourseware.vue?vue&type=script&lang=js"

import "./AudioCourseware.vue?vue&type=style&index=0&id=7e3c0437&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e3c0437"

export default script